<div class="mb-3 product-variant-period-block">
  <div class="form-group col-12 product-variant-period-block__section">
    <div class="row product-variant-period-block__row">
      <div class="col-12 col-sm-6 product-variant-period-block__period"
           [innerHTML]="translationService.getTranslation('period') + ': ' + (subscription.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' + ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))">
      </div>
    </div>
  </div>
  @if (showVariantDescription && subscription.variantDescription && showOrderNo) {
  <div class="form-group col-12 product-variant-period-block__section">
    <div class="row product-variant-period-block__row">
      <div class="col-12 col-sm-6 product-variant-period-block__commitment-date"
           [innerHTML]="translationService.getTranslation('order_id')  + ': ' + subscription.backendId">
      </div>
    </div>
  </div>
  }
  @if (subscription.commitmentDate && subscription.commitmentDate > today) {
    <div class="form-group col-12 product-variant-period-block__section">
      <div class="row product-variant-period-block__row">
        <div class="col-12 col-sm-6 product-variant-period-block__commitment-date"
             [innerHTML]="translationService.getTranslation('commitmentDate')  + ': ' + subscription.commitmentDate | date: translationService.getTranslation('dateFormat')">
        </div>
      </div>
    </div>
  }
  @if (showProductDescription) {
    <div class="form-group col-12 product-variant-period-block__section">
      <div class="row product-variant-period-block__row">
        <div class="col-12 col-sm-6 product-variant-period-block__product-description"
             [innerHTML]="translationService.getTranslation('order_product') + ': ' + subscription.productDescription">
        </div>
      </div>
    </div>
  }
  @if (showVariantDescription && subscription.variantDescription) {
    <div class="form-group col-12 product-variant-period-block__section">
      <div class="row product-variant-period-block__row">
        <div class="col-12 col-sm-6 product-variant-period-block__variant-description"
             [innerHTML]="translationService.getTranslation('order_edition') + ': ' + subscription.variantDescription">
        </div>
      </div>
    </div>
  }
</div>
